// extracted by mini-css-extract-plugin
module.exports = {"cms_numbered_footnotes":"Footnotes__cms_numbered_footnotes___3S2lQ"};